<template lang="pug">
  v-container(fluid)
    v-stepper(v-model="step.current")
      v-stepper-header
        v-stepper-step(step="1", :editable="step.editable1") {{ translations.steps.title1 }}
        v-divider
        v-stepper-step(step="2", :editable="step.editable2") {{ translations.steps.title2 }}
        v-divider
        v-stepper-step(step="3", :editable="step.editable3") {{ translations.steps.title3 }}
      v-stepper-items
        v-stepper-content(step="1")
          ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator1")
            v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitStep(1))")
              v-container(fluid)
                v-row
                  v-col(cols="12" sm="6")
                    BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
                  v-col(cols="12" sm="6")
                    BaseTextField(rules="required" v-model="form.id", :label="translations.label.id")
                  v-col(cols="12" sm="6")
                    BaseDatePickerRange(rules="required" v-model="form.daterange", :label="translations.label.daterange")
                  v-col(cols="12").my-0.py-0
                    v-btn.float-right(:disabled="invalid"
                      color="primary"
                      type="submit") {{ translations.button.next }}
        v-stepper-content(step="2")
          ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator2")
            v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitStep(2))")
              v-container(fluid)
                v-row
                  v-col(cols="12" sm="6")
                    BaseSelectField(:items="typeListAll" v-model="form.type", :label="translations.label.type" @input="changeType")
                  v-col(v-if="form.type == 'simple' || form.type == 'regular'" cols="12" sm="6")
                    BaseTextField(rules="required|numeric|min_value:0" v-model="form.rounds", :label="translations.label.rounds")
                  v-col(cols="12")
                    BaseAutocompleteEmptyField(rules="required", :items="gamesListAll" v-model="form.games", :label="translations.label.games")
                  v-col(cols="12")
                    FreespinsGameSimpleCardGroup(v-if="form.type == 'simple'" v-model="form.games")
                    FreespinsGameRegularCardGroup(v-else-if="form.type == 'regular'", :items="form.games", v-model="form.gamesRegular")
                    FreespinsGameVariableCardGroup(v-else-if="form.type == 'variable'", :items="form.games", v-model="form.gamesVariable")
                  v-col(cols="12").my-0.py-0
                    v-btn.float-right(:disabled="invalid"
                      color="primary"
                      type="submit") {{ translations.button.next }}
        v-stepper-content(step="3")
          ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator3")
            v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
              v-container(fluid)
                v-row
                  v-col(cols="12")
                    BaseSelectField(rules="required", :items="operatorsListAll" v-model="form.operator", :label="translations.label.operator" @input="changeOperator")
                  v-col(cols="12")
                    v-switch(v-model="usersAll")
                      template(v-slot:label)
                        span(v-if="usersAll")
                          | {{ translations.label.selection }}: {{ translations.label.manual }} | 
                          strong {{ translations.label.all }}
                        span(v-else)
                          | {{ translations.label.selection }}: 
                          strong {{ translations.label.manual }}
                          |  | {{ translations.label.all }}
                  v-col(cols="12")
                    BaseChipSelectField(:rules="{required: !usersAll}", :items="usersListAll" v-model="form.users", :label="translations.label.users", :disabled="usersDisable")
                  v-col(cols="12").my-0.py-0
                    v-btn.float-right(:disabled="invalid"
                      color="primary"
                      type="submit"
                      :loading="loadingCreate") {{ translations.button.send }}

</template>

<script>

  import FreespinsGameSimpleCardGroup from '@/components/cards/FreespinsGameSimpleCardGroup';
  import FreespinsGameRegularCardGroup from '@/components/cards/FreespinsGameRegularCardGroup';
  import FreespinsGameVariableCardGroup from '@/components/cards/FreespinsGameVariableCardGroup';

  export default {
    name: "FreespinsCreate",
    components: {
      FreespinsGameSimpleCardGroup,
      FreespinsGameRegularCardGroup,
      FreespinsGameVariableCardGroup,
    },
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() =>({
      step: {
        current: 1,
        editable1: true,
        editable2: false,
        editable3: false,
      },
      form:{
        name: '',
        id: '',
        daterange: [],
        type: 'simple',
        rounds: null,
        games: [],
        gamesRegular: [],
        gamesVariable: [],
        operator: null,
        users: [],
      },
      usersAll: false,
    }),
    computed:{
      loadingCreate() {
        return this.$store.state.statusCode.createFreespins.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createFreespins.state;
      },
      typeListAll(){
        return [
          {
            text: 'Simple',
            value: 'simple'
          },
          {
            text: 'Regular',
            value: 'regular'
          },
          {
            text: 'Variable',
            value: 'variable'
          },
        ];
      },
      gamesListAll() {
        return this.$store.state.games.map(operator => ({
          text: operator.n,
          value: operator._id
        }));
      },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => ({
          text:operator.n,
          value:operator._id
        }));
      },
      usersListAll() {
        if(this.$store.state.users.docs != undefined){
          return this.$store.state.users.docs.map(user => ({
            text: user.r,
            value: user._id,
          }));
        } else {
          return [];
        }
      },
      usersDisable() {
        if(this.form.operator != null && this.usersListAll.length > 0 && !this.usersAll){
          return false;
        } else {
          return true;
        }
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator1.reset();
          this.$refs.validator2.reset();
          this.$refs.validator3.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
      usersAll: function(val){
        if (val) {
          this.form.users = [];
        }
      },
    },
    created(){
      this.$store.dispatch('getGames');
      this.$store.dispatch('getOperators');
    },
    methods:{
      removeGame(id){
        this.form.games = this.form.games.filter((game)=>{
          return game.value != id;
        });
      },
      changeType(){
        this.form.games = [];
        this.form.gamesRegular = [];
        this.form.gamesVariable = [];
        this.$refs.validator2.reset();
      },
      changeOperator(){
        this.form.users = [];
        this.$refs.validator3.reset();

        let userParams = {
          offset: 0,
          limit: 50,
          operator: this.form.operator,
          id: '',
          start: '',
          end: '',
        };
        this.$store.dispatch('getUsers',userParams);
      },
      getDateIsoString(date){
        const [day, month, year] = date.split('/');
        return new Date(year, month - 1, day).toISOString();
      },
      submitStep(n){
        this.step.current = n+1;
        this.step['editable' + (n+1)] = true;
      },
      submitDataForm(){
        let formSend = {
          data: {
            name: this.form.name,
            id: this.form.id,
            startdate: this.getDateIsoString(this.form.daterange[0]),
            enddate: this.getDateIsoString(this.form.daterange[1]),
            type: this.form.type,
            operator: this.form.operator,
          }
        };
        if(this.form.type == 'simple'){
          formSend.data.games = this.form.games.map((game)=>({game: game.value}));
          formSend.data.rounds = this.form.rounds;
        } else if (this.form.type == 'regular'){
          formSend.data.games = this.form.gamesRegular.map((game)=>({game: game.value, packages: game.packages}));
          formSend.data.rounds = this.form.rounds;
        } else if(this.form.type == 'variable'){
          formSend.data.games = this.form.gamesVariable.map((game)=>({game: game.value, packages: game.packages}));
        }
        if(this.usersAll){
          formSend.data.usersAll = true;
        } else {
          formSend.data.users = this.form.users.map((user)=>(user.value));
        }
        this.$store.dispatch('createFreespins', formSend);
      },
      clearFields(){
        this.step.current = 1;
        this.step.editable1 = true;
        this.step.editable2 = false;
        this.step.editable3 = false;
        this.form.name = '';
        this.form.id = '';
        this.form.daterange = [];
        this.form.type = 'simple';
        this.form.rounds = null;
        this.form.games = [];
        this.form.gamesRegular = [];
        this.form.gamesVariable = [];
        this.form.operator = null;
        this.form.users = [];
        this.usersAll = false;
      },
    }
  }
</script>

<style lang="sass">
</style>